<template>
    <div>
        <div class="flex-level fs-3">
            <div class="flex-item-left">
                <h3>{{ $l10n.__('Relances effectuées') }}</h3>
                <p>{{ $l10n.__('Liste des relances déjà envoyées sur ce document.') }}</p>
            </div>

            <div class="flex-item-right">
                <paginator
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    @pagination:update="navigate"
                />
            </div>
        </div>

        <dunning-list :dunnings="sentDunnings" />

        <div v-if="dunningState !== 'completed'">
            <div class="flex-left fs-3">
                <h3>{{ $l10n.__('Relances à venir') }}</h3>
                <p>{{ $l10n.__('Liste des 10 prochaines relances à venir sur ce document.') }}</p>
            </div>

            <dunning-enable
                v-if="canChaseClient"
                :enabled="dunningState == 'enabled'"
                :enableLabel="$t.__('documents.overview.tab.Dunning.activated')"
                :disableLabel="$t.__('documents.overview.tab.Dunning.disabled')"
                :description="$t.__('documents.overview.tab.Dunning.automatic_dunning')"
                @update:enabled="dialogVisible = true"
            />

            <div v-if="plannedErrors" class="dunning-alerts">
                <CompassAlert
                    v-for="(msg, index) in plannedErrors"
                    :key="index"
                    type="error"
                    :description="msg"
                    :showClose="false"
                />
            </div>

            <dunning-list v-if="dunningState == 'enabled'" :dunnings="plannedDunnings" />
        </div>

        <CompassDialog
            :visible.sync="dialogVisible"
            size="small"
            :title="dialogTitle"
            @before-close="closeDialog"
        >
            <template #default>
                <div class="dialog__default">
                    <p class="typographies-paragraph-medium-regular">{{ dialogMessage }}</p>
                </div>
            </template>
            <template #footer>
                <div class="dialog__footer">
                    <CompassButton
                        :label="$t.__('common.actions.cancel')"
                        type="secondary"
                        @click="closeDialog"
                    />
                    <CompassButton
                        :label="dialogConfirmText"
                        type="primary"
                        class="ml-3"
                        @click="toggle"
                    />
                </div>
            </template>
        </CompassDialog>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import DunningList from './dunning/DunningList.vue';
import DunningEnable from 'vcomponents/preferences/DunningEnable.vue';
import Paginator from 'vcomponents/utilities/Paginator.vue';
const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    components: {
        DunningList,
        DunningEnable,
        Paginator,
    },
    props: {
        canChaseClient: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            dialogVisible: false,
        };
    },
    computed: {
        ...mapState({
            doctype: (state) => state.doctype,
            dunningState: (state) => state.dunningState,
            sentDunnings: (state) => state.sentDunnings,
            sentDunningsNumber: (state) => state.sentDunningsNumber,
            plannedDunnings: (state) => state.plannedDunnings,
            plannedErrors: (state) => state.plannedErrors,
        }),
        pagination() {
            return {
                current_page: 1,
                last_page: Math.ceil(this.sentDunningsNumber / 10),
                total: this.sentDunningsNumber,
            };
        },
        toggleError() {
            return this.dunningState == 'enabled'
                ? this.$l10n.__('Impossible de désactiver les relances')
                : this.$l10n.__('Impossible de réactiver les relances');
        },
        dialogTitle() {
            return this.dunningState == 'enabled'
                ? this.$l10n.__('Désactivation des relances automatiques')
                : this.$l10n.__('Activation des relances automatiques');
        },
        dialogMessage() {
            let message = '';
            if (this.dunningState == 'enabled') {
                switch (this.doctype) {
                    case 'estimate':
                        message = this.$l10n.__(
                            "Confirmez-vous vouloir désactiver l'ensemble des relances automatiques à venir sur votre devis ? Sachez qu'il est possible de les réactiver.",
                        );
                        break;
                    case 'invoice':
                        message = this.$l10n.__(
                            "Confirmez-vous vouloir désactiver l'ensemble des relances automatiques à venir sur votre facture ? Sachez qu'il est possible de les réactiver.",
                        );
                        break;
                    case 'proforma':
                        message = this.$l10n.__(
                            "Confirmez-vous vouloir désactiver l'ensemble des relances automatiques à venir sur votre proforma ? Sachez qu'il est possible de les réactiver.",
                        );
                        break;
                }
            } else {
                switch (this.doctype) {
                    case 'estimate':
                        message = this.$l10n.__(
                            'Confirmez-vous vouloir activer la relance automatique sur votre devis ?',
                        );
                        break;
                    case 'invoice':
                        message = this.$l10n.__(
                            'Confirmez-vous vouloir activer la relance automatique sur votre facture ?',
                        );
                        break;
                    case 'proforma':
                        message = this.$l10n.__(
                            'Confirmez-vous vouloir activer la relance automatique sur votre proforma ?',
                        );
                        break;
                }
            }
            return message;
        },
        dialogConfirmText() {
            return this.dunningState == 'enabled'
                ? this.$l10n.__('Confirmer la désactivation')
                : this.$l10n.__("Confirmer l'activation");
        },
    },

    mounted: function () {
        this.$store.dispatch('documentOverview/getPlannedDunnings');
        this.navigate(1);
    },

    methods: {
        toggle() {
            this.$store
                .dispatch('documentOverview/toggleDunningForDoc')
                .then(() => {
                    this.$store.dispatch('documentOverview/getPlannedDunnings');
                })
                .catch(() => Push.error(this.toggleError));
            this.closeDialog();
        },
        navigate(page) {
            this.$store.dispatch('documentOverview/getSentDunnings', page);
        },
        closeDialog: function () {
            this.dialogVisible = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';
.dunning-alerts {
    padding-bottom: spacer(2);
}
.dunning-modal {
    .dialog__default > p {
        margin: 0;
    }
}
</style>
